import PromotionsInnerPageC from './PromotionsInnerPageC';
export default PromotionsInnerPageC;
